/* import __COLOCATED_TEMPLATE__ from './bounce-uploader.hbs'; */
import BounceUploaderCompact from './bounce-uploader-compact';

export default class BounceUploaderComponent extends BounceUploaderCompact {
  get queueName() {
    return `project-version-${this.args.projectVersion.id}-bounces`;
  }
}
